module.exports = __webpack_public_path__ + "static/media/03.ca0e35ef.png";